<template>
  <ul class="site_menu">
    <li v-for="item in menu" :key="item.id">
      <router-link :to="item.to" :class="{ is_current: $route.path === item.to }">
        {{ item.label }}
      </router-link>
    </li>
  </ul>
</template>

<script>
// The main navigation, shared by the header, the mobile drawer and the footer.
// Which item is current follows the router; router-link sets aria-current.

import siteMenu from '@/data/siteMenu'

export default {
  name: 'SiteMenu',

  data() {
    return { menu: siteMenu }
  },
}
</script>

<style scoped>
.site_menu {
  display: flex;
  align-items: center;
}

.site_menu a {
  display: block;
  padding: 10.2px;
  color: rgba(10, 10, 11, 0.88);
  transition: color 0.2s ease;
}

.site_menu a:hover {
  color: var(--accent);
}
</style>
